import { VideoNoticiasData } from "../../../../data/data";

import VideoContainer from "./VideoContainer";
import { ScrollHorizontal } from "../../ScrollHorizontal";
import { Link } from "react-router-dom";

export default function VideoNoticias() {
  return (
    <section>
      <ScrollHorizontal
        contenido={[...VideoNoticiasData.slice(2, VideoNoticiasData.length)]
          .reverse()
          .map((video, index) => (
            <Link
              style={{
                textDecoration: "none",
                color: "black",
                fontSize: "0.8rem",
              }}
              to={`/reproducir-videos/noticias/${video.id}`}
              key={index}
            >
              <VideoContainer
                titulo={video.titulo}
                descripcion={video.descripcion}
                caratula={video.caratula}
              />
            </Link>
          ))}
      />
    </section>
  );
}
